import React, {useEffect, useContext, useState, useRef} from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "./../../../Public/img/logo-black.png";
import userlogo from "./../../../Public/img/dashboard-user.png";
import { AuthContext } from "../../../context/AuthContext";
import $ from 'jquery';


const Header = () =>{

    const navigate = useNavigate();
    const {user, setUser} = useContext(AuthContext);
    const [showprofiledropdown, setShowProfileDropDown] = useState(false);
    const [loggedname, setLoggedName] = useState("");
    const [alertmessage, setAlertMessage] = useState([]);
    const [isalertshow, setIsAlertShow] = useState(false);
    const [prifileimage, setProfileImage] = useState("");
    const profiledropdownRef = useRef(null);
    const alertdropdownRef = useRef(null);
    const [showalertdd, setShowAlertDD] = useState(false);
    const [notifications, setNotifications] = useState([
    { id: 1, name: "Rahul Sharma", followup: "Call at 5 PM" },
    { id: 2, name: "Priya Singh", followup: "Send quotation" },
    { id: 3, name: "Amit Verma", followup: "Meeting tomorrow" },
  ]);

    const dashboardurl = `${window.location.origin}/caller/dashboard`;
    const profileimagepath = "http://api.edustack360.local/uploads/profile/";

    const $wrapper = $('.main-wrapper');

    useEffect(() =>{

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event)
        {
            if (profiledropdownRef.current && !profiledropdownRef.current.contains(event.target)) 
            {
                setShowProfileDropDown(false);
            }

            if (alertdropdownRef.current && !alertdropdownRef.current.contains(event.target)) 
            {
                setShowAlertDD(false);
            }
        }

    }, []);

    useEffect(()=>{

        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            setProfileImage(loggeduserdata.image);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, [])


    const handleShowProfileToggle = ()=>{
        setShowProfileDropDown(!showprofiledropdown);
    }

    const handleShowAlertToggle = () =>{
        setShowAlertDD(!showalertdd);   
    }

    const handleMobileSidebar = () =>{
        
        $wrapper.toggleClass('slide-nav');
		$('.sidebar-overlay').toggleClass('opened');
		//$('html').addClass('menu-opened');
		$('#task_window').removeClass('opened');
		return false;
    }

    const handleHideMobileMenu = () =>{
        console.log('Clicked me');
        $wrapper.toggleClass('slide-nav');
		$('.sidebar-overlay').removeClass('opened');
		//$('html').addClass('menu-opened');
		$('#task_window').removeClass('opened');
		return false;
    }

    const handleLogout = () =>{

        localStorage.removeItem('cpmstoken');
        //sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');
        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    const handleAlertMessage = () =>{
        setIsAlertShow(!isalertshow);
    }

    return (
        <div className="header">

            {/*<Link id="mobile_btn" className="mobile_btn" to="#sidebar">
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </Link>*/}

            <button id="mobile_btn" className="mobile_btn"  onClick={handleMobileSidebar}>
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>

            <div class="sidebar-overlay" onClick={handleHideMobileMenu}></div>

            <div className="header-user">
                <ul className="nav user-menu">
                    <li className="nav-item nav-search-inputs me-auto">
                        <div class="crm-search-box">
                            <span class="crm-search-icon">⌕</span>
                            <input type="text" placeholder="Search..." />
                        </div>
                    </li>

                    {/*<li className="nav-item crm-top-icon">🔔</li>*/}
                    
                    {/*<li class="nav-item dropdown nav-item-box has-arrow main-drop">
                        <div className="dropdown alert-dropdown d-flex align-items-center justify-content-center" ref={alertdropdownRef}>

                            <div id="notificationDropdown" className={showalertdd ? "nav-link drop-arrow-none position-relative show" : "nav-link drop-arrow-none position-relative"}  data-bs-toggle="dropdown" onClick={handleShowAlertToggle}>                                
                                🔔
                                <span class="badge rounded-pill">{notifications.length}</span>
                            </div>

                            {showalertdd &&

                            <div class="dropdown-menu dropdown-menu-end notification-dropdown show crm-notification-dropdown">

                                <div class="crm-notification-header">
								    <div>
                                        <h4 class="crm-notification-title">Notifications</h4>
                                        <p class="crm-notification-subtitle">Recent follow-up alerts</p>
                                    </div>
							    </div>
							
								<div class="crm-notification-body">
                                    <ul class="crm-notification-list">
                                        <li class="crm-notification-item">
                                            <div className="crm-notification-link">
                                                <div class="crm-notification-avatar">SM</div>

                                                <div class="crm-notification-content">
                                                    <div class="crm-notification-top">
                                                        <p class="crm-notification-name">Ray Arnold</p>
                                                        <span class="crm-notification-time">01:50 PM</span>
                                                    </div>
                                                    <p class="crm-notification-phone">8285828282</p>
                                                    <p class="crm-notification-text">Follow-up scheduled</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="crm-notification-item">
                                            <div className="crm-notification-link">
                                                <div class="crm-notification-avatar">SM</div>
                                                <div class="crm-notification-content">
                                                    <div class="crm-notification-top">
                                                        <p class="crm-notification-name">Ray Arnold</p>
                                                        <span class="crm-notification-time">01:50 PM</span>
                                                    </div>
                                                    <p class="crm-notification-phone">8285828282</p>
                                                    <p class="crm-notification-text">Follow-up scheduled</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="crm-notification-item">
                                            <div className="crm-notification-link">
                                                <div class="crm-notification-avatar">SM</div>
                                                <div class="crm-notification-content">
                                                    <div class="crm-notification-top">
                                                        <p class="crm-notification-name">Ray Arnold</p>
                                                        <span class="crm-notification-time">01:50 PM</span>
                                                    </div>
                                                    <p class="crm-notification-phone">8285828282</p>
                                                    <p class="crm-notification-text">Follow-up scheduled</p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
								
								<div class="crm-notification-footer">
                                    <Link to="/caller/notifications" class="crm-notification-footer-link">View all notifications</Link>
                                </div>
								
							</div>
                            }
                        </div>
						
					</li>*/}

                    <li className="nav-item dropdown has-arrow main-drop">
                        <div className="dropdown profile-dropdown d-flex align-items-center justify-content-center" ref={profiledropdownRef}>
                            <div className={showprofiledropdown ? "topbar-link drop-arrow-none position-relative show" : "topbar-link  drop-arrow-none position-relative"} onClick={handleShowProfileToggle} >
                                
                                {prifileimage !== "" && prifileimage !==  null && prifileimage !== undefined ?
                                <img src={profileimagepath + prifileimage} width="38" className="rounded-circle d-flex" alt="user-image" />
                                :
                                <img src={userlogo} width="38" className="rounded-circle d-flex" alt="user-image" />

                                }

                                <span class="online text-success">
                                    <i class="ti ti-circle-filled d-flex bg-white rounded-circle border border-1 border-white"></i>
                                </span>
                                
                            </div>

                            {showprofiledropdown ?
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2 show" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                    <div class="ms-2">
                                        <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span class="d-block fs-13">Caller</span>
                                    </div>
                                </div>

                                <Link to="/caller/profile" class="dropdown-item">
                                    <i class="ti ti-user-circle me-1 align-middle"></i>
                                    <span class="align-middle">Profile Settings</span>
                                </Link>


                                
                                <div class="pt-2 mt-2 border-top">
                                    <button class="dropdown-item text-danger" onClick={handleLogout}>
                                        <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span class="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            :
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                    <div class="ms-2">
                                        <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span class="d-block fs-13">Caller</span>
                                    </div>
                                </div>

                                <Link to="/caller/profile" class="dropdown-item">
                                    <i class="ti ti-user-circle me-1 align-middle"></i>
                                    <span class="align-middle">Profile Settings</span>
                                </Link>

                                {/*<div class="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                                    <label class="form-check-label" for="notify"><i class="ti ti-bell"></i>Notifications</label>
                                    <input class="form-check-input me-0" type="checkbox" role="switch" id="notify" />
                                </div>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-help-circle me-1 align-middle"></i>
                                    <span class="align-middle">Help &amp; Support</span>
                                </Link>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-settings me-1 align-middle"></i>
                                    <span class="align-middle">Settings</span>
                                </Link>*/}            
                                
                                <div class="pt-2 mt-2 border-top">
                                    <button class="dropdown-item text-danger" onClick={handleLogout}>
                                        <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span class="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </li>
                    
                    {/*<li className="nav-item nav-item-email nav-item-box">
                        <div className="" style={{ cursor: "pointer" }} onClick={handleLogout}>
                            <svg  xmlns="http://www.w3.org/2000/svg"  width="34"  height="34"  viewBox="0 0 21 21"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-power">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M7 6a7.75 7.75 0 1 0 10 0" />
                                <path d="M12 4l0 8" />
                            </svg>
                        </div>
                    </li>*/}

                    
                </ul>
            </div>

            
        </div>
    )

}

export default Header;
